// src/idle.js
import { api } from '@/services/api';
import { useAuthenticationStore } from '@/stores/auth';

const IDLE_LIMIT = 45 * 60 * 1000; // 45m
let idleTimer: ReturnType<typeof setTimeout> | null = null;
let pingInterval: ReturnType<typeof setInterval> | null = null;
const channel = new BroadcastChannel('idle-channel');

// whenever we see activity, reset our timer…
function resetTimer() {
  if (idleTimer) clearTimeout(idleTimer);
  idleTimer = setTimeout(logout, IDLE_LIMIT);
}

// …and broadcast it so other tabs reset too
function announceActivity() {
  resetTimer();
  channel.postMessage('activity');
}

channel.onmessage = (e) => {
  if (e.data === 'activity') {
    resetTimer();
  }
};

function logout() {
  const authStore = useAuthenticationStore();
  localStorage.setItem('sessionExpired', 'true');
  authStore.logout().catch(() => {});
}

// on app load…
export function initIdleWatcher() {
  announceActivity(); // start the timer
  // optional "keep-alive" pings if the tab's hidden
  // watch for activity…
  ['mousemove', 'keydown', 'mousedown', 'touchstart', 'click'].forEach((evt) => {
    window.addEventListener(evt, announceActivity);
  });
  api.post(import.meta.env.VITE_API_URL + 'users/keep-alive', {}, { withCredentials: true }).catch(() => {});
  pingInterval = setInterval(
    () => api.post(import.meta.env.VITE_API_URL + 'users/keep-alive', {}, { withCredentials: true }).catch(() => {}),
    5 * 60 * 1000
  );
}

export function teardownIdleWatcher() {
  if (idleTimer) clearTimeout(idleTimer);
  if (pingInterval) clearInterval(pingInterval);
  channel.close();
  ['mousemove', 'keydown', 'mousedown', 'touchstart', 'click'].forEach((evt) => {
    window.removeEventListener(evt, announceActivity);
  });
}
